var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallWhiteFood = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "display/small/tertiary/food") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "display/small/tertiary/food",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-20",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3066751,9.27196875 C21.4544391,9.47730281 22.395809,10.0928653 23.1316685,11.1186562 C23.7791365,12.0274903 24.2206522,13.1706778 24.4557737,14.5482187 C24.6621679,15.8088028 24.6466994,17.0689472 24.4115779,18.3295312 C24.0584537,20.4105722 23.3522054,22.1548125 22.2928328,23.5618125 C21.0270661,25.2620841 19.4382282,26.112 17.5254354,26.112 C17.0543085,26.112 16.5398698,25.9655841 15.9803514,25.6723125 C15.597616,25.4379591 15.1711269,25.3205625 14.7,25.3205625 C14.2288731,25.3205625 13.8028259,25.4379591 13.4196486,25.6723125 C12.8601302,25.9655841 12.3456915,26.112 11.8745646,26.112 C9.96177178,26.112 8.37293394,25.2620841 7.10716716,23.5618125 C6.04779462,22.1548125 5.34154626,20.4105722 4.98842207,18.3295312 C4.75330059,17.0689472 4.73783207,15.8088028 4.94422631,14.5482187 C5.17934779,13.1706778 5.62086351,12.0274903 6.2683315,11.1186562 C7.00419102,10.0928653 7.94556087,9.47730281 9.09332495,9.27196875 C9.79957331,9.15457219 10.7705543,9.25745906 12.0067099,9.57975 C13.0660825,9.87302156 13.9636985,10.2247716 14.699558,10.635 C15.4354176,10.2247716 16.3330336,9.87302156 17.3924061,9.57975 C18.6290037,9.25745906 19.6004267,9.15457219 20.3066751,9.27196875 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8785596,7.46925 C17.466655,7.85045906 16.9217212,8.12878125 16.245084,8.30465625 C15.7739571,8.45107219 15.2595184,8.5245 14.7,8.5245 L14.0379474,8.48053125 C13.979167,8.07030281 13.979167,7.60115625 14.0379474,7.07353125 C14.1559501,6.01828125 14.4940477,5.21233406 15.0531242,4.65525 C15.4650287,4.27404094 16.0099625,3.99571875 16.6865997,3.81984375 C17.1577266,3.67342781 17.6721654,3.6 18.2316838,3.6 L18.8937364,3.64396875 L18.9379321,4.3035 C18.9379321,4.86058406 18.8641252,5.37325969 18.7173953,5.84240625 C18.5410541,6.51644719 18.2617369,7.05902156 17.8785596,7.46925 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallWhiteFood);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-white-food.e9a8b09e0d50e809a25064848e8f6752.svg";